// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_patient_document.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { Created, Deleted, Revision } from "./dto_base_pb.js";
import { MedicalImageViewOptions } from "./dto_common_image_view_options_pb.js";

/**
 * PatientDocument is a collaboratively editable Markdown document attached to a patient.
 *
 * The document owns an ordered list of image references (Images) and the
 * presentation metadata (caption and view settings) for each referenced patient
 * asset. It does not own uploaded bytes: a user-uploaded image first becomes a
 * normal patient asset (AssetType_Patient_UploadedImage) and the document only
 * references it.
 *
 * @generated from message com.diagnocat.model.PatientDocument
 */
export const PatientDocument = proto3.makeMessageType(
  "com.diagnocat.model.PatientDocument",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "OriginThreadID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "Images", kind: "message", T: PatientDocumentImage, repeated: true },
    { no: 15, name: "NextImageID", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 10030, name: "Created", kind: "message", T: Created },
    { no: 10040, name: "Revision", kind: "message", T: Revision },
    { no: 10050, name: "Deleted", kind: "message", T: Deleted },
  ],
);

/**
 * PatientDocumentImage is an image the document renders as a figure. It
 * references a patient asset by its platform AssetID and carries the
 * document-local presentation metadata (caption and view options) for that
 * instance. The referenced patient asset is kept immutable and reusable; the
 * same source asset can be inserted more than once with different settings.
 *
 * @generated from message com.diagnocat.model.PatientDocumentImage
 */
export const PatientDocumentImage = proto3.makeMessageType(
  "com.diagnocat.model.PatientDocumentImage",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "Caption", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "AssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ViewOptions", kind: "message", T: MedicalImageViewOptions },
  ],
);

